module.exports = __webpack_public_path__ + "static/one-on-one-conversation-19d870675aad10eb4322baf9227788e5.png";